import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../Components/SEO';
import SEOPageLayout from '../../Components/SEOPageLayout';

export default function Contact() {
  const [formStatus, setFormStatus] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormStatus('success');
    // For visual purposes only as requested
  };

  const contactSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "CheckScript AI",
    "url": "https://checkscript.online",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "customer support",
        "email": "support@checkscript.online",
        "availableLanguage": "English"
      },
      {
        "@type": "ContactPoint",
        "contactType": "sales",
        "email": "partners@checkscript.online",
        "availableLanguage": "English"
      }
    ]
  };

  return (
    <SEOPageLayout>
      <SEO
        title="Contact CheckScript — Support & Partnership Inquiries"
        description="Get in touch with the CheckScript AI team for technical support, partnership inquiries, or general questions about our assessment tools."
        keywords="contact CheckScript, CheckScript support, CheckScript help, CheckScript email"
        path="/contact"
        structuredData={contactSchema}
      />

      <section className="seo-hero seo-animate">
        <div className="seo-mesh-bg"></div>
        <div className="seo-container seo-container--sm">
          <div className="seo-hero-badge">✉️ Get In Touch</div>
          <h1 className="seo-h1">
            We're Here to <span className="seo-gradient-text">Help</span>
          </h1>
          <p className="seo-lead">
            Whether you need technical support for Neural Driver, have billing questions, or want to join our Vendor program, our team is ready to assist.
          </p>
        </div>
      </section>

      <section className="seo-section seo-section--alt seo-animate">
        <div className="seo-container">
          <div className="seo-grid seo-grid--3 seo-mb-64">
            <div className="seo-bento-box seo-bento-square seo-text-center">
              <div className="seo-card-icon seo-card-icon--cyan seo-mx-auto">🛠️</div>
              <h3 className="seo-h3">Technical Support</h3>
              <p className="seo-text-secondary seo-mb-16">Having trouble setting up? We offer dedicated support sessions.</p>
              <a href="mailto:support@checkscript.online" className="seo-label" style={{ display: 'inline-block' }}>support@checkscript.online</a>
            </div>
            
            <div className="seo-bento-box seo-bento-square seo-text-center">
              <div className="seo-card-icon seo-card-icon--amber seo-mx-auto">🤝</div>
              <h3 className="seo-h3">Partner Program</h3>
              <p className="seo-text-secondary seo-mb-16">Interested in bulk licensing or becoming a reseller?</p>
              <a href="mailto:partners@checkscript.online" className="seo-label" style={{ display: 'inline-block' }}>partners@checkscript.online</a>
            </div>
            
            <div className="seo-bento-box seo-bento-square seo-text-center">
              <div className="seo-card-icon seo-card-icon--emerald seo-mx-auto">❓</div>
              <h3 className="seo-h3">General Inquiries</h3>
              <p className="seo-text-secondary seo-mb-16">Have a feature request or general question?</p>
              <a href="mailto:info@checkscript.online" className="seo-label" style={{ display: 'inline-block' }}>info@checkscript.online</a>
            </div>
          </div>

          <div className="seo-bento-grid" style={{ gap: '48px', maxWidth: '1000px', margin: '0 auto' }}>
            <div className="seo-glass-card">
              <h2 className="seo-h2 seo-mb-24">Send us a message</h2>
              {formStatus === 'success' ? (
                <div style={{ padding: '24px', background: 'rgba(16, 185, 129, 0.1)', borderRadius: '12px', border: '1px solid var(--seo-emerald)', color: 'var(--seo-emerald)', textAlign: 'center' }}>
                  <h3 className="seo-h3">Message Sent!</h3>
                  <p>Thank you for reaching out. We typically respond within 24 hours.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="seo-mb-16">
                    <label className="seo-label" style={{ color: 'var(--seo-text-secondary)' }}>Your Name</label>
                    <input type="text" required style={{ width: '100%', padding: '12px 16px', background: 'rgba(0,0,0,0.3)', border: '1px solid var(--seo-border)', borderRadius: '8px', color: '#fff', outline: 'none' }} />
                  </div>
                  <div className="seo-mb-16">
                    <label className="seo-label" style={{ color: 'var(--seo-text-secondary)' }}>Email Address</label>
                    <input type="email" required style={{ width: '100%', padding: '12px 16px', background: 'rgba(0,0,0,0.3)', border: '1px solid var(--seo-border)', borderRadius: '8px', color: '#fff', outline: 'none' }} />
                  </div>
                  <div className="seo-mb-16">
                    <label className="seo-label" style={{ color: 'var(--seo-text-secondary)' }}>Subject</label>
                    <select style={{ width: '100%', padding: '12px 16px', background: 'rgba(0,0,0,0.3)', border: '1px solid var(--seo-border)', borderRadius: '8px', color: '#fff', outline: 'none', appearance: 'none' }}>
                      <option value="support">Technical Support</option>
                      <option value="billing">Billing Inquiry</option>
                      <option value="partner">Partnership / Vendor</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div className="seo-mb-24">
                    <label className="seo-label" style={{ color: 'var(--seo-text-secondary)' }}>Message</label>
                    <textarea rows="4" required style={{ width: '100%', padding: '12px 16px', background: 'rgba(0,0,0,0.3)', border: '1px solid var(--seo-border)', borderRadius: '8px', color: '#fff', outline: 'none', resize: 'vertical' }}></textarea>
                  </div>
                  <button type="submit" className="seo-btn seo-btn--primary seo-w-full seo-flex-center">Send Message</button>
                </form>
              )}
            </div>

            <div>
              <h2 className="seo-h2">Quick Answers</h2>
              <p className="seo-text-secondary seo-mb-32">Before reaching out, your question might already be answered in our resources.</p>
              
              <Link to="/faq" className="seo-link-card seo-mb-16">
                <span style={{ fontSize: '1.4rem' }}>❓</span>
                <div>
                  <h4 className="seo-mb-0">Frequently Asked Questions</h4>
                  <p className="seo-text-secondary" style={{ fontSize: '0.85rem' }}>Pricing, installation, and setup answers.</p>
                </div>
                <span className="seo-link-card-arrow">→</span>
              </Link>
              
              <Link to="/partners" className="seo-link-card seo-mb-16">
                <span style={{ fontSize: '1.4rem' }}>🤝</span>
                <div>
                  <h4 className="seo-mb-0">Partner Program Details</h4>
                  <p className="seo-text-secondary" style={{ fontSize: '0.85rem' }}>Learn about bulk licensing and ROI.</p>
                </div>
                <span className="seo-link-card-arrow">→</span>
              </Link>
              
              <Link to="/download" className="seo-link-card">
                <span style={{ fontSize: '1.4rem' }}>⬇️</span>
                <div>
                  <h4 className="seo-mb-0">Download Center</h4>
                  <p className="seo-text-secondary" style={{ fontSize: '0.85rem' }}>Get the latest v19.0.0 client.</p>
                </div>
                <span className="seo-link-card-arrow">→</span>
              </Link>

              <div className="seo-mt-48">
                <h3 className="seo-h4 seo-mb-16">Support Hours</h3>
                <p className="seo-text-secondary">Monday - Friday: 9:00 AM - 6:00 PM (IST)<br />Weekend support available for Premium partners.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </SEOPageLayout>
  );
}
